import { Component, OnDestroy, EventEmitter, OnInit, Output } from '@angular/core';
import { ColCatService } from '../../shop/services/col-cat.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-category-sidebar',
  styleUrls: ['./category-sidebar.component.scss'],
  templateUrl: './category-sidebar.component.html'
})

export class CateogrySidebarComponent implements OnDestroy, OnInit {

  private decorStatus = false;
  private lightingStatus = false;
  private mirrorsStatus = false;
  private otherStatus = false;
  private outdoorStatus = false;
  private seatingStatus = false;
  private tablesStatus = false;
  // ------------------------
  private isChecked: boolean;
  private route: any;
  private routerVal = this.router.url;
  private subCollections: any[];
  private subscription: Subscription;

  public collectionsStatus = false;
  public collections: any[];
  public categories: any[];
  public subCategories: any[];

  @Output() emitParent: EventEmitter<any> = new EventEmitter();

  constructor(
    public router: Router,
    private colCatService: ColCatService
  ) {}

  ngOnInit(): void {
    this.subscription =
      this.colCatService.getCollections().subscribe(data => this.collections = data),
      this.colCatService.subCollection().subscribe(data => this.subCollections = data),
      this.colCatService.category().subscribe(data => this.categories = data),
      this.colCatService.subCategory().subscribe(data => this.subCategories = data);

      const tempVal = this.router.url.split('/');
      this.routerVal = tempVal[1];
      console.log('Activated sidebar for: ' + tempVal + ' component');
  
      if (this.routerVal === 'collections') {
        this.collectionsStatus = true;
      } else if (this.routerVal === 'decor') {
        this.decorStatus = true;
      } else if (this.routerVal === 'lighting') {
        this.lightingStatus = true;
      } else if (this.routerVal === 'mirrors') {
        this.mirrorsStatus = true;
      } else if (this.routerVal === 'other') {
        this.otherStatus = true;
      } else if (this.routerVal === 'outdoor') {
        this.outdoorStatus = true;
      } else if (this.routerVal === 'seating') {
        this.seatingStatus = true;
      } else if (this.routerVal === 'tables') {
        this.tablesStatus = true;
      }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private getKeys(obj): any {
    return Object.keys(obj);
  }

  private sendChange(value: string): void {
    this.emitParent.emit(value);
  }

  private targetParent(event): void {
    const target = event.target;
    const parent = target.parentElement;
    parent.classList.add('active');
  }

  public toggleMenus(event): void {
    if (event.target.classList.contains('collections-title')) {
      // this.collectionsStatus = false;
      this.decorStatus = false;
      this.lightingStatus = false;
      this.mirrorsStatus = false;
      this.otherStatus = false;
      this.outdoorStatus = false;
      this.seatingStatus = false;
      this.tablesStatus = false;
    } else if (event.target.classList.contains('seating-title')) {
      this.collectionsStatus = false;
      this.decorStatus = false;
      this.lightingStatus = false;
      this.mirrorsStatus = false;
      this.otherStatus = false;
      this.outdoorStatus = false;
      // this.seatingStatus = false;
      this.tablesStatus = false;
    } else if (event.target.classList.contains('tables-title')) {
      this.collectionsStatus = false;
      this.decorStatus = false;
      this.lightingStatus = false;
      this.mirrorsStatus = false;
      this.otherStatus = false;
      this.outdoorStatus = false;
      this.seatingStatus = false;
      // this.tablesStatus = false;
    } else if (event.target.classList.contains('lighting-title')) {
      this.collectionsStatus = false;
      this.decorStatus = false;
      // this.lightingStatus = false;
      this.mirrorsStatus = false;
      this.otherStatus = false;
      this.outdoorStatus = false;
      this.seatingStatus = false;
      this.tablesStatus = false;
    } else if (event.target.classList.contains('mirrors-title')) {
      this.collectionsStatus = false;
      this.decorStatus = false;
      this.lightingStatus = false;
      // this.mirrorsStatus = false;
      this.otherStatus = false;
      this.outdoorStatus = false;
      this.seatingStatus = false;
      this.tablesStatus = false;
    } else if (event.target.classList.contains('decor-title')) {
      this.collectionsStatus = false;
      // this.decorStatus = false;
      this.lightingStatus = false;
      this.mirrorsStatus = false;
      this.otherStatus = false;
      this.outdoorStatus = false;
      this.seatingStatus = false;
      this.tablesStatus = false;
    } else if (event.target.classList.contains('other-title')) {
      this.collectionsStatus = false;
      this.decorStatus = false;
      this.lightingStatus = false;
      this.mirrorsStatus = false;
      // this.otherStatus = false;
      this.outdoorStatus = false;
      this.seatingStatus = false;
      this.tablesStatus = false;
    } else if (event.target.classList.contains('outdoor-title')) {
      this.collectionsStatus = false;
      this.decorStatus = false;
      this.lightingStatus = false;
      this.mirrorsStatus = false;
      this.otherStatus = false;
      // this.outdoorStatus = false;
      this.seatingStatus = false;
      this.tablesStatus = false;
    }
  }

  private toggleCollections(): void {
    this.collectionsStatus = !this.collectionsStatus;
  }

  private toggleDecor(): void {
    this.decorStatus = !this.decorStatus;
  }

  private toggleLighting(): void {
    this.lightingStatus = !this.lightingStatus;
  }

  private toggleMirrors(): void {
    this.mirrorsStatus = !this.mirrorsStatus;
  }

  private toggleOther(): void {
    this.otherStatus = !this.otherStatus;
  }

  private toggleOutdoor(): void {
    this.outdoorStatus = !this.outdoorStatus;
  }

  private toggleSeating(): void {
    this.seatingStatus = !this.seatingStatus;
  }

  private toggleTables(): void {
    this.tablesStatus = !this.tablesStatus;
  }

}
